import {Record} from 'immutable';
import moment from 'moment';
import periodOptions from 'components/triggers/trigger-actions/periodOptions';
import subPeriodOptions from 'components/triggers/trigger-actions/subPeriodOptions';
import comparatorOptions from 'utils/const/comparatorOptions';

export default class TriggerTrend extends Record({
  id: null,
  created: null,
  modified: null,
  userId: undefined,
  ruleId: null,
  period: null,
  inequalityType: null,
  threshold: null,
  dampingDelay: undefined,
  lastFired: null,
  trendType: null,
  antiRuleId: null,
  subPeriod: null,
}) {
  constructor(props = {}) {
    super({
      ...props,
      created: moment(props.created),
      modified: moment(props.modified),
    });
  }
  getSubPeriodText() {
    return subPeriodOptions.find(o => o.value === this.subPeriod).label;
  }
  getPeriodText() {
    return periodOptions.find(o => o.value === this.period).label;
  }
  getThresholdText() {
    const comparatorOption = comparatorOptions.find(o => o.value === this.inequalityType);
    const units = this.trendType === TrendType.PERCENTAGE_OF_TIMES ? '%' : '';
    return `${comparatorOption.label} ${this.threshold}${units}`;
  }
}

export const TrendType = Object.freeze({
  COUNT_OF_TIMES: 'COUNT_OF_TIMES',
  AVERAGE_OF_TIMES: 'AVERAGE_OF_TIMES',
  PERCENTAGE_OF_TIMES: 'PERCENTAGE_OF_TIMES',
});
